import { useState } from "react";
import { Link } from "react-router-dom";
import { Package, Heart, MapPin, LogOut, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { useShop } from "../store/ShopContext";
import { PageHeader } from "../components/PageHeader";

export default function Account() {
  const { user, login, logout, wishlist } = useShop();
  const [email, setEmail] = useState("");
  const [mode, setMode] = useState("login");

  const submit = (e) => {
    e.preventDefault();
    login(email);
    toast.success(mode === "login" ? "Autentificare demo reușită" : "Cont demo creat");
  };

  if (!user) {
    return (
      <div data-testid="account-page">
        <PageHeader eyebrow="Cont client" title={mode === "login" ? "Bine ai revenit" : "Creează un cont"} description="Autentificare demo, doar la nivel de interfață. Nu se creează conturi reale și nu se stochează parole." testId="account-header" />
        <div className="container-cc grid grid-cols-1 lg:grid-cols-12 gap-12">
          <form onSubmit={submit} data-testid="account-login-form" className="lg:col-span-5 space-y-5">
            <label className="block"><span className="eyebrow block mb-2">Email</span><input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-cc" placeholder="adresa@email.ro" /></label>
            <label className="block"><span className="eyebrow block mb-2">Parolă</span><input data-testid="login-password" type="password" required className="input-cc" placeholder="••••••••" /></label>
            {mode === "register" && <label className="block"><span className="eyebrow block mb-2">Nume complet</span><input data-testid="register-name" className="input-cc" /></label>}
            <button data-testid="login-submit" className="btn-primary w-full">{mode === "login" ? "Autentifică-te" : "Creează cont"} <ArrowRight size={16} /></button>
            <button type="button" data-testid="account-toggle-mode" onClick={() => setMode(mode === "login" ? "register" : "login")} className="text-sm underline underline-offset-4 text-[#5A5A5A]">
              {mode === "login" ? "Nu ai cont? Înregistrează-te" : "Ai deja cont? Autentifică-te"}
            </button>
          </form>
          <div className="lg:col-span-6 lg:col-start-7 surface p-10">
            <p className="font-serif text-3xl font-light">Avantajele contului</p>
            <ul className="mt-6 space-y-4 text-sm text-[#5A5A5A]">
              <li className="flex gap-3"><Package size={18} strokeWidth={1.2} className="text-[#B4A38E] shrink-0" /> Istoric comenzi și documente într-un singur loc</li>
              <li className="flex gap-3"><Heart size={18} strokeWidth={1.2} className="text-[#B4A38E] shrink-0" /> Lista de favorite sincronizată pe toate dispozitivele</li>
              <li className="flex gap-3"><MapPin size={18} strokeWidth={1.2} className="text-[#B4A38E] shrink-0" /> Adrese salvate pentru un checkout mai rapid</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="account-dashboard">
      <PageHeader eyebrow="Contul meu" title={`Bună, ${user.name}`} description={user.email} testId="account-header" />
      <div className="container-cc grid grid-cols-1 md:grid-cols-3 gap-5">
        <div className="surface p-8">
          <Package size={22} strokeWidth={1.2} className="text-[#B4A38E]" />
          <p className="font-serif text-2xl mt-5">Comenzi</p>
          <p className="text-sm text-[#737373] mt-2">Nu ai comenzi reale. Comenzile demo plasate nu se asociază contului în această fază.</p>
        </div>
        <Link to="/favorite" className="surface p-8 group">
          <Heart size={22} strokeWidth={1.2} className="text-[#B4A38E]" />
          <p className="font-serif text-2xl mt-5">Favorite</p>
          <p className="text-sm text-[#737373] mt-2">{wishlist.length} produse salvate</p>
          <span className="btn-ghost mt-4">Vezi lista <ArrowRight size={14} /></span>
        </Link>
        <div className="surface p-8">
          <MapPin size={22} strokeWidth={1.2} className="text-[#B4A38E]" />
          <p className="font-serif text-2xl mt-5">Adrese</p>
          <p className="text-sm text-[#737373] mt-2">Nicio adresă salvată. Funcționalitate disponibilă după lansare.</p>
        </div>
      </div>
      <div className="container-cc mt-10">
        <button data-testid="logout-btn" onClick={() => { logout(); toast("Te-ai deconectat"); }} className="btn-outline"><LogOut size={16} /> Deconectare</button>
      </div>
    </div>
  );
}
